import React, { HTMLAttributes } from "react";
import cx from "clsx";
import { CommonComponentProps } from "./componentTypes";

interface BlockquoteProps
  extends HTMLAttributes<HTMLQuoteElement>,
    CommonComponentProps {}

export function Blockquote({ children, className, ...rest }: BlockquoteProps) {
  return (
    <blockquote
      className={cx("mt-6 border-l-2 pl-6 italic", className)}
      {...rest}
    >
      {children}
    </blockquote>
  );
}
